import { useSelector } from 'react-redux';
import { getCurrencySymbol, toFixedTrunc } from '../../../../client/Juno/helpers';

const ExchangeConfirmation = ({ formData, quotationData }) => {
    const { balancesCrypto } = useSelector(state => state.juno);
    const imageBaseUrl = useSelector(state => state.config.image_base_url);

    const fromCrypto = balancesCrypto.find(
        x => x.currencyShortName === formData.fromCryptoId?.currencyShortName,
    );
    const toCrypto = balancesCrypto.find(
        x => x.currencyShortName === formData.toCryptoId?.currencyShortName,
    );

    const fromCurrencyShortName = formData.fromCryptoId?.currencyShortName;
    const toCurrencyShortName = formData.toCryptoId?.currencyShortName;

    return (
        <div className="flex flex-col gap-6">
            <div className="">
                <p className="text-xs font-medium text-balanceCard-manage uppercase mb-2">From</p>
                <div className=" border !border-[#D1D1D6] dark:!border-[#51525C] bg-card-bg rounded-md p-3">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            {fromCrypto && (
                                <img
                                    src={`${imageBaseUrl}${fromCrypto?.currencyIcon}`}
                                    width={24}
                                    height={24}
                                    alt="cryptoIcon"
                                />
                            )}
                            <span className="text-base font-medium !text-text">
                                {fromCurrencyShortName}
                            </span>
                        </div>
                        <p
                            className="text-xl font-medium !text-text"
                            data-e2e='from-crypto-confirm-amount'
                            data-e2e-amount={formData.fromCryptoAmount}
                            data-e2e-curren={fromCurrencyShortName}>
                            {getCurrencySymbol(fromCurrencyShortName)}{' '}
                            {formData.fromCryptoAmount} (
                            {fromCurrencyShortName})
                        </p>
                    </div>
                    <hr className="!border-[#D1D1D6] dark:!border-[#51525C] h-[1px] my-2" />
                    <div className="flex justify-between items-center">
                        <p className="text-xs font-medium text-balanceCard-manage">Balance:</p>
                        <p className="text-xs font-normal text-balanceCard-manage">
                            {fromCrypto?.balanceAmount}
                        </p>
                    </div>
                </div>
            </div>
            <div className="">
                <p className="text-xs font-medium text-balanceCard-manage uppercase mb-2">TO</p>
                <div className=" border !border-[#D1D1D6] dark:!border-[#51525C] bg-card-bg rounded-md p-3">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            {toCrypto && (
                                <img
                                    src={`${imageBaseUrl}${toCrypto?.currencyIcon}`}
                                    width={24}
                                    height={24}
                                    alt="cryptoIcon"
                                />
                            )}
                            <span className="text-base font-medium !text-text">
                                {toCurrencyShortName}
                            </span>
                        </div>
                        <p
                            className="text-xl font-medium !text-text"
                            data-e2e='to-crypto-confirm-amount'
                            data-e2e-curren={toCurrencyShortName}>
                            {getCurrencySymbol(toCurrencyShortName)}{' '}
                            {formData.toCryptoAmount} (
                            {toCurrencyShortName})
                        </p>
                    </div>
                    <hr className="!border-[#D1D1D6] dark:!border-[#51525C] h-[1px] my-2" />
                    <div className="flex justify-between items-center">
                        <p className="text-xs font-medium text-balanceCard-manage">Balance:</p>
                        <p className="text-xs font-normal text-balanceCard-manage">
                            {toCrypto?.balanceAmount}
                        </p>
                    </div>
                </div>
            </div>

            <div className=" border !border-[#D1D1D6] dark:!border-[#51525C] bg-card-bg rounded-md p-3 !text-text">
                <p className="text-center">
                    1 {fromCurrencyShortName} ={' '}
                    {quotationData?.price}{' '}
                    {toCurrencyShortName}
                </p>
            </div>

            {quotationData?.error && (
                <p className="text-error text-sm mt-1 font-normal font-Inter uppercase">
                    Error while fetching quotation
                </p>
            )}
        </div>
    );
};

export default ExchangeConfirmation;
